export const FORM_OFFICE_API_VALUES = ["MALTA", "UKRAINE", "POLAND"] as const;

export type FormOfficeApi = (typeof FORM_OFFICE_API_VALUES)[number];

/** Maps task/applicant office to POST /applicant-accounting/create `form_office` enum. */
export const normalizeFormOfficeForApi = (value?: string | null): FormOfficeApi | "" => {
  const upper = String(value ?? "").trim().toUpperCase();
  if (!upper || upper === "ALL") return "";
  return (FORM_OFFICE_API_VALUES as readonly string[]).includes(upper) ? (upper as FormOfficeApi) : "";
};
